function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from 'react';
import styled from 'styled-components';
import { border, borderRadius, height, width } from 'styled-system';
import Box from '../Box';
const StyledPrefix = styled(Box).withConfig({
  displayName: "Prefix__StyledPrefix",
  componentId: "sc-jdyf3s-0"
})(["", " ", " ", " ", " white-space:nowrap;border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;"], border, borderRadius, height, width);
const Prefix = /*#__PURE__*/memo(_ref => {
  let {
    as = 'span',
    bg = 'gray.1',
    border = 'default',
    borderRadius = 'corner',
    display = 'block',
    height = 40,
    px = 3,
    py = 2,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledPrefix, _extends({
    as: as,
    bg: bg,
    border: border,
    borderRadius: borderRadius,
    display: display,
    height: height,
    px: px,
    py: py
  }, props));
});
Prefix.propTypes = {
  ...Box.propTypes,
  ...borderRadius.propTypes,
  ...height.propTypes
};
Prefix.displayName = 'Prefix';
export default Prefix;